module.exports = __webpack_public_path__ + "static/media/bet1.3ddfcbc6.jpg";